'use strict';

let style = document.createElement('style');
document.head.appendChild(style);

let setted = false;

document.addEventListener('mousedown', _set);
document.addEventListener('touchstart', _set);
document.addEventListener('keydown', _remove);


function _set() {
  if (setted) return;

  style.innerHTML = '* {outline:none}';
  // document.documentElement.classList.add('no-outline');
  setted = true;
}
function _remove(e) {
  if (!setted) return;
  if (e && e.keyCode !== 9) return;

  style.innerHTML = '';
  // document.documentElement.classList.remove('no-outline');
  setted = false;
}